import { render, staticRenderFns } from "./TruckCommodity.vue?vue&type=template&id=bd782a60"
import script from "./TruckCommodity.vue?vue&type=script&lang=ts"
export * from "./TruckCommodity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports